<template>
  <g>
    <path
      d="M25.682 27.65L18.0487 20L25.682 12.35L23.332 10L13.332 20L23.332 30L25.682 27.65Z"
      fill="black"
    />
  </g>
</template>
